export const environment = {
  production: true,

  usersApi: "https://edelegate.unmeetings.org/users",
  countriesApi: "https://edelegate.unmeetings.org/countries",
  announcementsApi: "https://edelegate.unmeetings.org/announcements",
  committeeplaceApi: "https://edelegate.unmeetings.org/committeeplace",
  listOfMeetingsApi: "https://edelegate.unmeetings.org/meetings",
  eDecisionsApi: "https://edelegate.unmeetings.org/edecisions",
  meetingsApi: "https://edelegate.unmeetings.org/inscriptions",
  inscriptionMeetingsApi: "https://edelegate.unmeetings.org/elistofspeakers",
  eListOfSpeakersApi: "https://edelegate.unmeetings.org/elistofspeakers",
  lookupsApi: "https://edelegate.unmeetings.org/lookups",
  eregistrationApi: "https://edelegate.unmeetings.org/eregistration",
  ecredentialsApi: "https://edelegate.unmeetings.org/credentials",
  meetingsparticipantsApi:
    "https://edelegate.unmeetings.org/meetingsparticipants",
  delegatesApi: "https://edelegate.unmeetings.org/delegates",
  pDelegateApi: "https://edelegatedevecs.unmeetings.org/pdelegate",
  eSpeakersApi: "https://edelegatedevecs.unmeetings.org/espeakers",
  dataUrl: "https://bluebook.uat.un.int/data.json",
  env: "UAT",

  region: "us-east-1",
  identityPoolId: "",
  userPoolId: "us-east-1_wyOZAXlcr",
  provider: "uniteid",
  clientId: "3clqftijpnoqktud43ia1eh8hv",
  espeakersURL: "https://espeakers.unmeetings.org",
  callbackURL: "https://edelegate.unmeetings.org",
  signoutURL: "https://edelegate.unmeetings.org",
  appWebDomain: "edelegate.auth.us-east-1.amazoncognito.com",
  rekognitionBucket: "rekognition-pics",
  albumName: "usercontent",
  bucketRegion: "us-east-1",
  ddbTableName: "LoginTrail",
  cognito_idp_endpoint: "",
  cognito_identity_endpoint: "",
  sts_endpoint: "",
  dynamodb_endpoint: "",
  s3_endpoint: "",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts